import React, { useState, useEffect } from 'react'
import { Menu, MenuItem, Button, Checkbox, FormControlLabel } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const ChannelListItem = ({ channel, isChecked, isDisabled, setValues, unit, selectAll, setInitialValues }) => {
    const [setUnitMenuAnchorEl, onSetUnitMenuAnchorElChange] = useState(null)
    const [selectedUnit, setSelectedUnit] = useState(unit)
    const [isSelected, setIsSelected] = useState(isChecked)

    useEffect(() => {
        setIsSelected(isChecked);
    }, [isChecked, selectAll]);

    const closeSetUnitMenu = () => {
        onSetUnitMenuAnchorElChange(null)
    }

    const handleUnitSelect = (unit) => {
        setSelectedUnit(unit)
        if (isSelected)
            setValues(values => {
                values.find(value => value.id === channel.id).unit = unit
                return values
            })
        closeSetUnitMenu()
    }

    const checkboxClicked = (e) => {
        e.persist();
        setIsSelected(e.target.checked);
        setValues(values => {
            if (e.target.checked)
                return [...values, { ...channel, unit: selectedUnit }]
            else
                return values.filter(value => value.id !== channel.id)
        })
        setInitialValues(values => {
            if (e.target.checked)
                return [...values, { ...channel, unit: selectedUnit }]
            else
                return values.filter(value => value.id !== channel.id)
        })
    }

    const unitOptions = Array.isArray(channel.units) ? channel.units : []
    const hasUnit = selectedUnit && selectedUnit !== '-'

    return (
        <div
            className={`channelRow${isSelected ? ' channelRow--selected' : ''}${isDisabled ? ' channelRow--disabled' : ''}`}
            key={channel.id}
        >
            <FormControlLabel
                className="channelRowLabel"
                control={
                    <Checkbox
                        size="small"
                        color="default"
                        disabled={isDisabled}
                        checked={isSelected}
                        onChange={checkboxClicked}
                    />
                }
                label={channel.nameLocalized}
                title={channel.nameLocalized}
            />

            {unitOptions.length > 1 ? (
                <Button
                    className="channelRowUnit"
                    size="small"
                    disabled={isDisabled}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={e => onSetUnitMenuAnchorElChange(e.currentTarget)}
                >
                    {hasUnit ? selectedUnit : '—'}
                </Button>
            ) : (
                <span className="channelRowUnit channelRowUnit--static">{hasUnit ? selectedUnit : ''}</span>
            )}
            <Menu
                anchorEl={setUnitMenuAnchorEl}
                open={Boolean(setUnitMenuAnchorEl)}
                onClose={closeSetUnitMenu}
            >
                {
                    unitOptions.map(unit => (
                        <MenuItem
                            key={unit}
                            selected={unit === selectedUnit}
                            onClick={() => handleUnitSelect(unit)}
                        >
                            {unit}
                        </MenuItem>
                    ))
                }
            </Menu>
        </div>
    )
}

export default ChannelListItem
